import "../sellscreendialogs.scss";
import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import { addPaymentToSale, type SaleAddPaymentOptions } from "../../../../Actions/SellScreen/SellScreenPaymentActions";
import Button from "../../../../Common/Buttons/Button";
import NoTranslate from "../../../../Common/NoTranslate";
import { currency } from "../../../../Utilities/Generic/Numbers";

const connector = connect();

type PropsFromRedux = ConnectedProps<typeof connector> & {
    dispatch: ThunkDispatch<any, any, any>;
};

interface Props extends PropsFromRedux {
    method: string;
    amount: number;
    name: string;
    options: SaleAddPaymentOptions;
}

interface State {
    value: string;
}

export class RequestRefund extends React.Component<Props, State> {
    public state = {
        value: "",
    };

    constructor(props: Readonly<Props>) {
        super(props);

        this.processRefund = this.processRefund.bind(this);
        this.cancelRequest = this.cancelRequest.bind(this);
    }

    public processRefund(): void {
        this.props.dispatch(hideDialog());
        this.props.dispatch(addPaymentToSale(this.props.method, this.props.amount, {
            ...this.props.options,
            refund: true,
        }));
    }

    public cancelRequest(): void {
        this.props.dispatch(hideDialog());
    }

    public render(): React.ReactNode {
        return (
            <div className="request-refund">
                <p>
                    Do you want to process a refund of{" "}
                    <NoTranslate>
                        {currency(this.props.amount * -1)}
                    </NoTranslate>
                    <br />
                    through <b>{this.props.name}</b>?
                </p>
                <div className="buttons">
                    <Button type="button" classes={[ "cancel-button" ]} onClick={this.cancelRequest}>Cancel</Button>
                    <Button type="button" classes={[ "button-danger" ]} onClick={this.processRefund}>Yes</Button>
                </div>
            </div>
        );
    }
}

export default connector(RequestRefund);
